$(document).ready(function(){



  $("input").change(function(){

    var def_pct, sb_def_pct, bb_def_pct = 0;

    if ($.isNumeric($("#combos").val())){
    var combos = parseInt($("#combos").val());
    $("#span_combos").text(combos);
    }
    else {
     $("#combos").val("Enter a number");
    };

    if ($.isNumeric($("#my_raise_bb").val())){
    var my_raise_bb = parseFloat($("#my_raise_bb").val());
    $("#span_my_raise").text(my_raise_bb);
    }
    else {
     $("#my_raise_bb").val("Enter a number!");
    };

    if ($.isNumeric($("#vill_3b_bb").val())){
    var vill_3b_bb = parseFloat($("#vill_3b_bb").val());
    $("#span_vill_3b").text(vill_3b_bb);
    }
    else {
     $("#vill_3b_bb").val("Enter a number!");
    };




    $("#defend_combos").val(getCombos(combos, my_raise_bb, vill_3b_bb));
    $("#def_combos").text(getCombos(combos, my_raise_bb, vill_3b_bb));
    $("#defend_pct").val(getDefPCT(my_raise_bb, vill_3b_bb)*100 + "%");

    $("#sb_defend_combos").val(getSBCombos(combos, my_raise_bb, vill_3b_bb));
    $("#sb_def_combos").text(getSBCombos(combos, my_raise_bb, vill_3b_bb));
    $("#sb_defend_pct").val(getSBDefPCT(my_raise_bb, vill_3b_bb)*100 + "%");

     $("#bb_defend_combos").val(getBBCombos(combos, my_raise_bb, vill_3b_bb));
     $("#bb_def_combos").text(getBBCombos(combos, my_raise_bb, vill_3b_bb));
     $("#bb_defend_pct").val(getBBDefPCT(my_raise_bb, vill_3b_bb)*100 + "%");


  });

  function getDefPCT(my_raise_bb, vill_3b_bb){
    let bbs = 1.5;
    let pot = bbs + my_raise_bb + vill_3b_bb;
    return (1 - (vill_3b_bb/pot)).toFixed(2);
  };

  function getSBDefPCT(my_raise_bb, vill_3b_bb){
    vill_3b_bb -= .5;
    return getDefPCT(my_raise_bb, vill_3b_bb);
  };

  function getBBDefPCT(my_raise_bb, vill_3b_bb){
    vill_3b_bb -= 1;
    return getDefPCT(my_raise_bb, vill_3b_bb);
   };


function getCombos(combos, my_raise_bb, vill_3b_bb) {
  let def_pct = getDefPCT(my_raise_bb, vill_3b_bb);
  return (combos * def_pct).toFixed(2);
}

function getSBCombos(combos, my_raise_bb, vill_3b_bb) {
  let sb_def_pct = getSBDefPCT(my_raise_bb, vill_3b_bb);
  return (combos * sb_def_pct).toFixed(2);
}


function getBBCombos(combos, my_raise_bb, vill_3b_bb) {
  let bb_def_pct = getBBDefPCT(my_raise_bb, vill_3b_bb);
  return (combos * bb_def_pct).toFixed(2);
}


});
